// Auto-generated normalizer for table: CAR_BOOKING.VehiculoOdometro
export function vehiculoOdometroNormalize(row) {
  return {
    idLectura: row.idLectura ?? row.IdLectura ?? row['idLectura'] ?? 0,
    idVehiculo: row.idVehiculo ?? row.IdVehiculo ?? row['idVehiculo'] ?? 0,
    idReserva: row.idReserva ?? row.IdReserva ?? row['idReserva'] ?? 0,
    fechaLectura: row.fechaLectura ?? row.FechaLectura ?? row['fechaLectura'] ?? null,
    kmOdometro: row.kmOdometro ?? row.KmOdometro ?? row['kmOdometro'] ?? '',
    origen: row.origen ?? row.Origen ?? row['origen'] ?? '',
    notas: row.notas ?? row.Notas ?? row['notas'] ?? '',
    fechaCreacion: row.fechaCreacion ?? row.FechaCreacion ?? row['fechaCreacion'] ?? null,
    activo: row.activo ?? row.Activo ?? row['activo'] ?? false,
  };
}